const w = (window as any);

const config = w.mahFindInstallerConfig || {};

/*
Config values are set in Umbraco & are added to in the template. The text values are managed in the Umbraco dictionary.
This could be replaced by using i18n & language files.
*/

const defaults = {
  countryName: "",
  countryLat: "",
  countryLong: "",
  callMeLink: "",
  contentHeader: "Find an accredited dealer or installer",
  contentSubHeader: "Are you interested in getting DStv? Or do you already have DStv and need some assistance? Our dealers and installers will be able to help! Enter your city below to find your nearest contact and get in touch.",
  descriptionForAll: "",
  descriptionForDealers: "",
  descriptionForInstallers: "",
  enterYourCity: "Enter your city",
  useMyCurrentLocation: "Use my current location",
  all: "All",
  installers: "Installers",
  dealers: "Dealers",
  results: "Results"
};

class AppConfig {
  static get countryName() {
    return config.countryName;
  }

  static get countryLatitude() {
    return parseInt(config?.countryLat || defaults.countryLat);
  }

  static get countryLongitude() {
    return parseInt(config?.countryLong || defaults.countryLong);
  }

  static get callMeLink() {
    return config?.callMeLink || defaults.callMeLink;
  }

  static get contentHeader() {
    return config?.contentHeader || defaults.contentHeader;
  }

  static get contentSubHeader() {
    return config?.contentSubHeader || defaults.contentSubHeader;
  }

  static get descriptionForAll() {
    return config?.descriptionForAll || defaults.descriptionForAll;
  }

  static get descriptionForDealers() {
    return config?.descriptionForDealers || defaults.descriptionForDealers;
  }

  static get descriptionForInstallers() {
    return config?.descriptionForInstallers || defaults.descriptionForInstallers;
  }

  static get enterYourCity() {
    return config?.enterYourCity || defaults.enterYourCity;
  }

  static get useMyCurrentLocation() {
    return config?.useMyCurrentLocation || defaults.useMyCurrentLocation;
  }

  static get all() {
    return config?.all || defaults.all;
  }

  static get installers() {
    return config?.installers || defaults.installers;
  }

  static get dealers() {
    return config?.dealers || defaults.dealers;
  }

  static get results() {
    return config?.results || defaults.results;
  }

  static loadMore = "Load More";
}

export default AppConfig;
